import { inject, Injectable } from '@angular/core';
import { SentryService } from '@mkp/core/util-sentry';
import { selectIsMissingTranslationsEnabled } from '@mkp/debug/state';
import { APP_ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import { Store } from '@ngrx/store';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { TRANSLATION_KEY_REGEXP } from './translation-key.regexp';

@Injectable()
export class MissingTranslationSentryHandler implements MissingTranslationHandler {
  private readonly sentryService = inject(SentryService);
  private readonly environment = inject(APP_ENVIRONMENT_PROVIDER);
  private readonly isMissingTranslationsDebugEnabled = inject(Store).selectSignal(
    selectIsMissingTranslationsEnabled
  );

  handle({ key }: Pick<MissingTranslationHandlerParams, 'key'>): string {
    if (!key.includes('.') && !key.includes('_')) {
      return key;
    }

    if (this.environment.production) {
      // in prod: only dispatch a sentry error if the key satisfies the regexp (avoid spam)
      if (TRANSLATION_KEY_REGEXP.test(key)) {
        this.sentryService.captureWarning(getMessage(key));
      }
      // in dev: only show console message if the option is ticked in the debug-menu
    } else if (this.isMissingTranslationsDebugEnabled()) {
      if (TRANSLATION_KEY_REGEXP.test(key)) {
        // show error for missing keys when they satisfy the regexp
        console.error(getMessage(key));
      } else {
        // otherwise warn will suffice
        console.warn(getMessage(key));
      }
    }

    return key;
  }
}

const getMessage = (key: string) => `[MissingTranslationHandler]: '${key}'`;
